import AvantiTrainIcon from './AvantiTrainIcon';

export default AvantiTrainIcon;
